<template>
  <div v-if="show" class="tags-modal" @click.self="closeModal">
    <div class="tags-modal__shell" @click.stop>
      <div class="tags-modal__card">
        <div class="tags-modal__body">
          <aside
            class="tags-modal__left"
            :class="{ 'tags-modal__left--open': isExpanded }"
          >
            <div class="tags-modal__left-handle" @click="isExpanded = true">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 4H20.2C21.1941 4 22 4.80589 22 5.8V18.2C22 19.1941 21.1941 20 20.2 20H9M9 4H3.8C2.80589 4 2 4.80589 2 5.8V18.2C2 19.1941 2.80589 20 3.8 20H9M9 4V20"
                  stroke="#5A6F95"
                  stroke-width="2"
                />
              </svg>
              <div class="tags-modal__left-handle-spacer"></div>
            </div>

            <div v-if="isExpanded" class="tags-modal__left-panel">
              <div class="tags-modal__left-group tags-modal__left-group--first">
                <div class="tags-modal__left-top">
                  <div
                    class="tags-modal__left-top-row"
                    @click="addMyCategoryLikeSectionTitle"
                  >
                    <span class="tags-modal__left-top-section-title">{{
                      myCategoriesSectionTitle
                    }}</span>
                    <div class="tags-modal__left-top-create">
                      <span class="tags-modal__left-top-create-label"
                        >צור קטגוריה</span
                      >
                      <div class="tags-modal__left-add" aria-hidden="true">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 5V19M5 12H19"
                            stroke="#409FFF"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="cat in myCategories"
                  :key="cat.id"
                  class="tags-modal__left-item-wrap"
                >
                  <template v-if="editingCategoryId !== cat.id">
                    <div
                      class="tags-modal__left-item"
                      @click="scrollToCategory(cat.id)"
                    >
                      <span class="tags-modal__left-item-actions">
                        <button
                          v-if="categoryCanShareCategory(cat)"
                          type="button"
                          class="tags-modal__left-action-btn"
                          title="הגדרת גישה"
                          @click.stop="openCategoryShareModal(cat)"
                        >
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          v-if="categoryCanRename(cat)"
                          type="button"
                          class="tags-modal__left-action-btn"
                          title="עריכה"
                          @click.stop="startEditCategory(cat)"
                        >
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.6168 3.75204C16.8552 3.51361 17.1383 3.32448 17.4498 3.19545C17.7613 3.06641 18.0952 3 18.4324 3C18.7696 3 19.1035 3.06641 19.415 3.19545C19.7265 3.32448 20.0095 3.51361 20.248 3.75204C20.4864 3.99046 20.6755 4.27351 20.8046 4.58503C20.9336 4.89655 21 5.23043 21 5.56761C21 5.90479 20.9336 6.23868 20.8046 6.55019C20.6755 6.86171 20.4864 7.14476 20.248 7.38319L7.99283 19.6383L3 21L4.36168 16.0072L16.6168 3.75204Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </span>
                      <span class="tags-modal__left-item-label">
                        {{ cat.label }}
                        <span
                          v-if="
                            cat.isSharedFromOthers && cat.accessLevel != null
                          "
                          class="tags-modal__shared-access-badge"
                        >
                          {{ cat.accessLevel === 2 ? 'עריכה' : 'צפייה' }}
                        </span>
                      </span>
                    </div>
                  </template>
                  <div v-else class="tags-modal__left-item-edit">
                    <!-- <div
                      v-if="!cat.isPendingCreate"
                      class="tags-modal__left-item-name-bar"
                    >
                      {{ cat.label }}
                    </div> -->
                    <input
                      v-model="editingCategoryDraft"
                      type="text"
                      class="tags-modal__left-item-input"
                      :placeholder="categoryEditPlaceholder"
                      autofocus
                      @focus="onCategoryEditInputFocus"
                      @keydown.enter.prevent="confirmEditCategory"
                      @keydown.esc.prevent="cancelEditCategory"
                    />
                    <div class="tags-modal__left-item-edit-footer" dir="ltr">
                      <button
                        v-if="
                          categoryCanDeleteCategory(cat) && cat.apiId != null
                        "
                        type="button"
                        class="
                          tags-modal__left-item-edit-btn
                          tags-modal__left-item-edit-btn--delete
                        "
                        title="מחק"
                        @click="deleteEditingCategory"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 7.00002H20M8.57143 7.00021V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7.00021M10 11V17M14 11V17M18 7.00021V19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2V7.00021H18Z"
                            stroke="#FF6052"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                      <div class="tags-modal__left-item-edit-actions">
                        <button
                          type="button"
                          class="tags-modal__left-item-edit-btn"
                          title="בטל"
                          @click="cancelEditCategory"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 6L18 18M18 6L6 18"
                              stroke="#38455D"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="
                            tags-modal__left-item-edit-btn
                            tags-modal__left-item-edit-btn--confirm
                          "
                          title="שמור"
                          @click="confirmEditCategory"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 12.5L10 17.5L19 6.5"
                              stroke="#22B573"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="tags-modal__left-group tags-modal__left-group--shared"
              >
                <div class="tags-modal__left-subtitle">הקטגוריות של אחרים</div>
                <div
                  v-if="!sharedCategories.length"
                  class="tags-modal__left-shared-empty"
                >
                  אין קטגוריות משותפות
                </div>
                <div
                  v-for="cat in sharedCategories"
                  :key="cat.id"
                  class="tags-modal__left-item-wrap"
                >
                  <template v-if="editingCategoryId !== cat.id">
                    <div
                      class="tags-modal__left-item"
                      @click="scrollToCategory(cat.id)"
                    >
                      <span class="tags-modal__left-item-actions">
                        <button
                          v-if="categoryCanShareCategory(cat)"
                          type="button"
                          class="tags-modal__left-action-btn"
                          title="הגדרת גישה"
                          @click.stop="openCategoryShareModal(cat)"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          v-if="categoryCanRename(cat)"
                          type="button"
                          class="tags-modal__left-action-btn"
                          title="עריכה"
                          @click.stop="startEditCategory(cat)"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.6168 3.75204C16.8552 3.51361 17.1383 3.32448 17.4498 3.19545C17.7613 3.06641 18.0952 3 18.4324 3C18.7696 3 19.1035 3.06641 19.415 3.19545C19.7265 3.32448 20.0095 3.51361 20.248 3.75204C20.4864 3.99046 20.6755 4.27351 20.8046 4.58503C20.9336 4.89655 21 5.23043 21 5.56761C21 5.90479 20.9336 6.23868 20.8046 6.55019C20.6755 6.86171 20.4864 7.14476 20.248 7.38319L7.99283 19.6383L3 21L4.36168 16.0072L16.6168 3.75204Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </span>
                      <span class="tags-modal__left-item-label">
                        {{ cat.label }}
                        <span
                          v-if="
                            cat.isSharedFromOthers && cat.accessLevel != null
                          "
                          class="tags-modal__shared-access-badge"
                        >
                          {{ cat.accessLevel === 2 ? 'עריכה' : 'צפייה' }}
                        </span>
                      </span>
                    </div>
                  </template>
                  <div v-else class="tags-modal__left-item-edit">
                    <!-- <div
                      v-if="!cat.isPendingCreate"
                      class="tags-modal__left-item-name-bar"
                    >
                      {{ cat.label }}
                    </div> -->
                    <input
                      v-model="editingCategoryDraft"
                      type="text"
                      class="tags-modal__left-item-input"
                      :placeholder="categoryEditPlaceholder"
                      autofocus
                      @focus="onCategoryEditInputFocus"
                      @keydown.enter.prevent="confirmEditCategory"
                      @keydown.esc.prevent="cancelEditCategory"
                    />
                    <div class="tags-modal__left-item-edit-footer" dir="ltr">
                      <button
                        v-if="
                          categoryCanDeleteCategory(cat) && cat.apiId != null
                        "
                        type="button"
                        class="
                          tags-modal__left-item-edit-btn
                          tags-modal__left-item-edit-btn--delete
                        "
                        title="מחק"
                        @click="deleteEditingCategory"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4 7.00002H20M8.57143 7.00021V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7.00021M10 11V17M14 11V17M18 7.00021V19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2V7.00021H18Z"
                            stroke="#FF6052"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                      <div class="tags-modal__left-item-edit-actions">
                        <button
                          type="button"
                          class="tags-modal__left-item-edit-btn"
                          title="בטל"
                          @click="cancelEditCategory"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 6L18 18M18 6L6 18"
                              stroke="#38455D"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="
                            tags-modal__left-item-edit-btn
                            tags-modal__left-item-edit-btn--confirm
                          "
                          title="שמור"
                          @click="confirmEditCategory"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 12.5L10 17.5L19 6.5"
                              stroke="#22B573"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tags-modal__left-footer">
                <!-- <button type="button" class="tags-modal__icon-btn">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 15L6 5H18L20 15M4 15H8.36364L9.09091 17.3077H14.9091L15.6364 15H20M4 15V20H20V15M10 8H14M8 11H16"
                    stroke="#5A6F95"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button> -->

                <button
                  type="button"
                  class="tags-modal__icon-btn"
                  @click="isExpanded = false"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 4H20.2C21.1941 4 22 4.80589 22 5.8V18.2C22 19.1941 21.1941 20 20.2 20H9M9 4H3.8C2.80589 4 2 4.80589 2 5.8V18.2C2 19.1941 2.80589 20 3.8 20H9M9 4V20"
                      stroke="#5A6F95"
                      stroke-width="2"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </aside>

          <div class="tags-modal__right-wrap">
            <div class="tags-modal__search-row">
              <input
                v-model="tagsPanelSearchQuery"
                type="text"
                class="tags-modal__search"
                placeholder="יצירה או חיפוש תגיות"
                @input="debouncedOnTagsPanelSearch"
              />
            </div>
            <div ref="rightPanel" class="tags-modal__right">
              <div v-if="isCreatingTag" class="tags-modal__create-tag">
                <div class="tags-modal__create-tag-name">
                  <input
                    v-model="newTagLabel"
                    type="text"
                    class="tags-modal__create-tag-input"
                    placeholder="שם התג"
                    autofocus
                    @keydown.enter.prevent="confirmCreateTag"
                    @keydown.esc.prevent="cancelCreateTag"
                  />
                  <div class="tags-modal__color-picker-wrap">
                    <button
                      type="button"
                      class="tags-dot tags-modal__create-tag-dot-btn"
                      :style="{ backgroundColor: newTagColorHexNormalized }"
                      title="בחר צבע"
                      @click.stop="toggleTagColorPicker"
                    ></button>
                    <chrome-picker
                      v-show="tagColorPickerShow"
                      v-model="newTagColor"
                      :disable-alpha="true"
                      @click.native.stop
                    />
                  </div>
                </div>
                <div class="tags-modal__create-tag-select-wrap">
                  <CustomThreeSelect
                    v-model="newTagCategoryId"
                    :options="categoryTreeselectOptions"
                    :multiple="false"
                    :placeholder="'בחר קטגוריה'"
                    :open-direction="'bottom'"
                  />
                </div>
                <div
                  class="tags-modal__create-tag-footer"
                  :class="{
                    'tags-modal__create-tag-footer--create-only':
                      tagFormMode !== 'edit'
                  }"
                  dir="ltr"
                >
                  <button
                    v-if="tagFormMode === 'edit'"
                    type="button"
                    class="
                      tags-modal__left-item-edit-btn
                      tags-modal__left-item-edit-btn--delete
                    "
                    title="מחק"
                    @click="deleteEditingTag"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 7.00002H20M8.57143 7.00021V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7.00021M10 11V17M14 11V17M18 7.00021V19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2V7.00021H18Z"
                        stroke="#FF6052"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <div class="tags-modal__left-item-edit-actions">
                    <button
                      type="button"
                      class="tags-modal__left-item-edit-btn"
                      title="בטל"
                      @click="cancelCreateTag"
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 6L18 18M18 6L6 18"
                          stroke="#38455D"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="
                        tags-modal__left-item-edit-btn
                        tags-modal__left-item-edit-btn--confirm
                      "
                      title="שמור"
                      @click="confirmCreateTag"
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 12.5L10 17.5L19 6.5"
                          stroke="#22B573"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-for="cat in categoriesForTagsPanel"
                :key="cat.id"
                class="tags-modal__group"
              >
                <div
                  class="tags-modal__group-title"
                  :ref="`groupTitle-${cat.id}`"
                >
                  <div
                    v-if="bulkSelectUiActive"
                    class="tags-modal__group-bulk-check"
                    @click.stop
                  >
                    <CheckboxNew
                      :check="isBulkCategorySelected(cat)"
                      @checkedElem="toggleBulkCategory(cat)"
                    />
                  </div>
                  {{ cat.label }}
                </div>
                <div
                  v-for="tag in cat.tags || []"
                  :key="tag.id"
                  class="tags-modal__option"
                  :class="{
                    'tags-modal__option--bulk':
                      bulkSelectUiActive && !isInlineEditingTag(cat, tag),
                    'tags-modal__option--editing': isInlineEditingTag(cat, tag)
                  }"
                  @click="onTagOptionClick(cat, tag)"
                >
                  <template v-if="!isInlineEditingTag(cat, tag)">
                    <div class="tags-modal__option-main">
                      <div
                        v-if="bulkSelectUiActive"
                        class="tags-modal__option-bulk-check"
                        @click.stop
                      >
                        <CheckboxNew
                          :check="isBulkTagSelected(tag.id)"
                          @checkedElem="toggleBulkTag(tag.id)"
                        />
                      </div>
                      <div class="tags-check">
                        <span v-if="tag.selected"
                          ><svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.8346 6.66797L8.54297 14.168L4.16797 9.78485"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <span
                        class="tags-dot"
                        :class="tagDotPresetClass(tag)"
                        :style="tagDotHexStyle(tag)"
                      ></span>
                      <span class="tags-modal__option-label">{{
                        tag.label
                      }}</span>
                    </div>
                    <button
                      v-if="categoryCanEditTagsInCategory(cat)"
                      type="button"
                      class="tags-modal__option-edit-btn"
                      title="עריכה"
                      @click.stop="openEditTag(cat, tag)"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6168 3.75204C16.8552 3.51361 17.1383 3.32448 17.4498 3.19545C17.7613 3.06641 18.0952 3 18.4324 3C18.7696 3 19.1035 3.06641 19.415 3.19545C19.7265 3.32448 20.0095 3.51361 20.248 3.75204C20.4864 3.99046 20.6755 4.27351 20.8046 4.58503C20.9336 4.89655 21 5.23043 21 5.56761C21 5.90479 20.9336 6.23868 20.8046 6.55019C20.6755 6.86171 20.4864 7.14476 20.248 7.38319L7.99283 19.6383L3 21L4.36168 16.0072L16.6168 3.75204Z"
                          stroke="#5A6F95"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </template>
                  <div
                    v-else
                    class="tags-modal__option-inline-edit"
                    @click.stop
                  >
                    <div class="tags-modal__option-inline-edit-top">
                      <input
                        v-model="newTagLabel"
                        type="text"
                        class="tags-modal__option-input"
                        placeholder="שם התג"
                        autofocus
                        @keydown.enter.prevent="confirmCreateTag"
                        @keydown.esc.prevent="cancelCreateTag"
                      />
                      <div class="tags-modal__color-picker-wrap">
                        <button
                          type="button"
                          class="tags-dot tags-modal__create-tag-dot-btn"
                          :style="{ backgroundColor: newTagColorHexNormalized }"
                          title="בחר צבע"
                          @click.stop="toggleTagColorPicker"
                        ></button>
                        <chrome-picker
                          v-show="tagColorPickerShow"
                          v-model="newTagColor"
                          :disable-alpha="true"
                          @click.native.stop
                        />
                      </div>
                    </div>
                    <div class="tags-modal__option-inline-edit-category">
                      <CustomThreeSelect
                        v-model="newTagCategoryId"
                        :options="categoryTreeselectOptions"
                        :multiple="false"
                        :placeholder="'בחר קטגוריה'"
                        :open-direction="'bottom'"
                      />
                    </div>
                    <div
                      class="tags-modal__option-inline-edit-footer"
                      dir="ltr"
                    >
                      <div class="tags-modal__option-inline-edit-delete">
                        <button
                          type="button"
                          class="
                            tags-modal__left-item-edit-btn
                            tags-modal__left-item-edit-btn--delete
                          "
                          title="מחק"
                          @click="deleteEditingTag"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 7.00002H20M8.57143 7.00021V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7.00021M10 11V17M14 11V17M18 7.00021V19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2V7.00021H18Z"
                              stroke="#FF6052"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                      <div class="tags-modal__option-inline-edit-actions">
                        <button
                          type="button"
                          class="tags-modal__left-item-edit-btn"
                          title="בטל"
                          @click="cancelCreateTag"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 6L18 18M18 6L6 18"
                              stroke="#38455D"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="
                            tags-modal__left-item-edit-btn
                            tags-modal__left-item-edit-btn--confirm
                          "
                          title="שמור"
                          @click="confirmCreateTag"
                        >
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 12.5L10 17.5L19 6.5"
                              stroke="#22B573"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showSearchCreateTagRow"
                class="tags-modal__option tags-modal__option--search-suggest"
                @click.stop
              >
                <div class="tags-modal__option-main">
                  <button
                    type="button"
                    class="tags-modal__search-suggest-create"
                    :disabled="
                      !tagsPanelSearchTrimmed ||
                      resolvedSearchSuggestCategoryId == null ||
                      !searchSuggestCanCreateInCategory
                    "
                    @click="confirmCreateTagFromSearch"
                  >
                    צור
                  </button>
                  <div class="tags-modal__color-picker-wrap">
                    <button
                      type="button"
                      class="tags-dot tags-modal__create-tag-dot-btn"
                      :style="{
                        backgroundColor: searchSuggestColorHexNormalized
                      }"
                      title="בחר צבע"
                      @click.stop="toggleSearchSuggestTagColorPicker"
                    ></button>
                    <chrome-picker
                      v-show="searchSuggestTagColorPickerShow"
                      v-model="searchSuggestTagColor"
                      :disable-alpha="true"
                      @click.native.stop
                    />
                  </div>
                  <span class="tags-modal__option-label">{{
                    tagsPanelSearchTrimmed
                  }}</span>
                </div>
                <div class="tags-modal__option-search-aside" @click.stop>
                  <CustomThreeSelect
                    v-model="searchSuggestCategoryId"
                    :options="categoryTreeselectOptionsSearchRow"
                    :multiple="false"
                    :placeholder="'בחר קטגוריה'"
                    :open-direction="'bottom'"
                  />
                </div>
              </div>
            </div>
            <div class="tags-modal__footer">
              <template v-if="bulkMoveMode">
                <div class="tags-modal__footer-move">
                  <button
                    type="button"
                    class="tags-modal__bulk-back"
                    :disabled="isBulkMoving"
                    @click="exitBulkMoveMode"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12L19 12M19 12L13 6M19 12L13 18"
                        stroke="#5A6F95"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <div class="tags-modal__footer-move-center">
                    <div class="tags-modal__footer-move-select-wrap">
                      <CustomThreeSelect
                        v-model="moveTargetCategoryId"
                        :options="categoryTreeselectOptions"
                        :multiple="false"
                        :placeholder="'בחר קטגוריה'"
                        :open-direction="'top'"
                      />
                    </div>
                    <button
                      type="button"
                      class="tags-modal__bulk-move-apply"
                      title="העבר"
                      :disabled="
                        !bulkSelectedTagIds.length ||
                        moveTargetCategoryId == null ||
                        isBulkMoving
                      "
                      @click="confirmBulkMove"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 14H3.5L7 18M3 10H21L17.5 6"
                          stroke="#FFFFFF"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </template>
              <template v-else-if="bulkDeleteMode">
                <button
                  type="button"
                  class="tags-modal__bulk-delete"
                  :disabled="!bulkSelectedTagIds.length || isBulkDeleting"
                  @click="confirmBulkDelete"
                >
                  <span>מחק</span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.33203 5.83335H16.6654M7.14156 5.83351V4C7.14156 3.60218 7.29207 3.22064 7.55997 2.93934C7.82788 2.65804 8.19125 2.5 8.57013 2.5H11.4273C11.8061 2.5 12.1695 2.65804 12.4374 2.93934C12.7053 3.22064 12.8558 3.60218 12.8558 4V5.83351M8.33203 9.16668V14.1667M11.6654 9.16668V14.1667M14.9987 5.83351V16C14.9987 16.3978 14.8482 16.7794 14.5803 17.0607C14.3124 17.342 13.949 17.5 13.5701 17.5H6.42727C6.04839 17.5 5.68503 17.342 5.41712 17.0607C5.14921 16.7794 4.9987 16.3978 4.9987 16V5.83351H14.9987Z"
                      stroke="#FF6052"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="tags-modal__bulk-back"
                  :disabled="isBulkDeleting"
                  @click="exitBulkDeleteMode"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12L19 12M19 12L13 6M19 12L13 18"
                      stroke="#5A6F95"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </template>
              <template v-else>
                <div class="tags-modal__footer-actions">
                  <button
                    type="button"
                    class="tags-modal__icon-btn"
                    title="שינוי קטגוריה"
                    @click="enterBulkMoveMode"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 14H3.5L7 18M3 10H21L17.5 6"
                        stroke="#5A6F95"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    class="tags-modal__icon-btn"
                    title="מחיקה מרובה"
                    @click="enterBulkDeleteMode"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_41135_63184)">
                        <path
                          d="M6.57143 5.00021V2.8C6.57143 2.32261 6.75204 1.86477 7.07353 1.52721C7.39502 1.18964 7.83106 1 8.28571 1H11.7143C12.1689 1 12.605 1.18964 12.9265 1.52721C13.248 1.86477 13.4286 2.32261 13.4286 2.8V5.00021M2 5H18M8 9V15M12 9V15M8 21.9998H17.2853C17.74 21.9998 18.176 21.8102 18.4975 21.4726C18.819 21.135 18.9996 20.6772 18.9996 20.1998V8H20.9996M16 5.00021V17.2C16 17.6774 15.8194 18.1352 15.4979 18.4728C15.1764 18.8104 14.7404 19 14.2857 19H5.71429C5.25963 19 4.82359 18.8104 4.5021 18.4728C4.18061 18.1352 4 17.6774 4 17.2V5.00021H16Z"
                          stroke="#5A6F95"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_41135_63184">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                  <button
                    type="button"
                    class="
                      tags-modal__icon-btn tags-modal__mobile-categories-toggle
                    "
                    title="קטגוריות"
                    @click="isExpanded = true"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 4H20.2C21.1941 4 22 4.80589 22 5.8V18.2C22 19.1941 21.1941 20 20.2 20H9M9 4H3.8C2.80589 4 2 4.80589 2 5.8V18.2C2 19.1941 2.80589 20 3.8 20H9M9 4V20"
                        stroke="#5A6F95"
                        stroke-width="2"
                      />
                    </svg>
                  </button>
                </div>
                <button
                  type="button"
                  class="tags-modal__create-btn"
                  @click="openCreateTag"
                >
                  <span>צור תג</span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 5V19M5 12H19"
                      stroke="#409FFF"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TagsCategoryShareModal
      :show="categoryShareModalOpen"
      :category="shareCategory"
      :campus-id="campusId"
      @close="closeCategoryShareModal"
    />
  </div>
</template>

<script>
import TagsCategoryShareModal from '@/Pages/Student/Blocks/Student/TagsCategoryShareModal.vue';
import CustomThreeSelect from '@/Components/UI/Form/CustomThreeSelect.vue';
import CheckboxNew from '@/Components/UI/Form/CheckBoxModal.vue';
import { Chrome } from 'vue-color';
import axios from 'axios';
import { myPlaginDebounce } from '@/Plugins/helper';

const TAGS_TOAST = {
  loadCategoriesError: 'שגיאה בטעינת הקטגוריות',
  saveTagError: 'שגיאה בשמירת התג',
  renameCategoryError: 'שגיאה בעדכון הקטגוריה',
  deleteCategoryError: 'שגיאה במחיקת הקטגוריה',
  deleteTagError: 'שגיאה במחיקת התג',
  createCategoryError: 'שגיאה ביצירת הקטגוריה',
  bulkDeleteInvalid: 'לא ניתן למחוק את הבחירה',
  bulkDeleteLimit: 'ניתן למחוק עד 200 תגיות בבת אחת',
  bulkDeleteOk: 'נמחק',
  bulkDeleteError: 'שגיאה במחיקה',
  bulkMoveInvalid: 'לא ניתן להעביר את הבחירה',
  bulkMoveLimit: 'ניתן להעביר עד 200 תגיות בבת אחת',
  bulkMoveOk: 'התגיות הועברו',
  bulkMoveError: 'שגיאה בהעברת התגיות'
};

export default {
  name: 'TagsModal',
  components: {
    TagsCategoryShareModal,
    CustomThreeSelect,
    CheckboxNew,
    'chrome-picker': Chrome
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedTags: {
      type: Array,
      default: () => []
    },
    campusId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      isExpanded: false,
      myCategoriesSectionTitle: 'הקטגוריות שלי',
      myCategoryNextId: 1,
      myCategories: [],
      sharedCategories: [],
      isLoadingCategories: false,
      editingCategoryId: null,
      editingCategoryDraft: '',
      categoryEditPlaceholder: 'קטגוריה חדשה',
      categoryEditShouldSelect: false,
      isCreatingTag: false,
      tagFormMode: 'create',
      editingTagId: null,
      editingTagFromCategoryId: null,
      newTagLabel: '',
      newTagCategoryId: null,
      newTagColor: {
        hex: '#22B573',
        source: 'hex'
      },
      tagColorPickerShow: false,
      nextTagId: 1,
      bulkDeleteMode: false,
      isBulkDeleting: false,
      bulkMoveMode: false,
      isBulkMoving: false,
      bulkSelectedTagIds: [],
      moveTargetCategoryId: null,
      categoryShareModalOpen: false,
      shareCategory: null,
      tagsPanelSearchQuery: '',
      tagsCategoriesLoadGen: 0,
      searchSuggestCategoryId: null,
      searchSuggestTagColor: { hex: '#22B573', source: 'hex' },
      searchSuggestTagColorPickerShow: false,
      searchSuggestRowColorInited: false,
      /** Полный список категорий при активном поиске (для селекта «צור»). */
      categoriesLookupExtras: []
    };
  },
  computed: {
    bulkSelectUiActive() {
      return this.bulkDeleteMode || this.bulkMoveMode;
    },
    categoriesForTagsPanel() {
      return this.myCategories
        .concat(this.sharedCategories)
        .filter(c => !c.isPendingCreate);
    },
    categoryTreeselectOptions() {
      return this.categoriesForTagsPanel.map(cat => ({
        id: cat.id,
        label: cat.label
      }));
    },
    /** Селект строки поиска: при поиске — все категории из второго запроса без search. */
    categoryTreeselectOptionsSearchRow() {
      if (this.categoriesLookupExtras.length) {
        return this.categoriesLookupExtras.map(c => ({
          id: c.id,
          label: c.label
        }));
      }
      return this.categoryTreeselectOptions;
    },
    tagsPanelSearchTrimmed() {
      return (this.tagsPanelSearchQuery || '').trim();
    },
    showSearchCreateTagRow() {
      if (this.tagsPanelSearchTrimmed.length < 1) {
        return false;
      }
      if (this.bulkSelectUiActive) {
        return false;
      }
      if (this.isCreatingTag) {
        return false;
      }
      if (this.tagFormMode === 'edit' && this.editingTagId) {
        return false;
      }
      return this.categoryTreeselectOptionsSearchRow.length > 0;
    },
    resolvedSearchSuggestCategoryId() {
      const opts = this.categoryTreeselectOptionsSearchRow;
      if (!opts.length) {
        return null;
      }
      const id = this.searchSuggestCategoryId;
      if (id != null && id !== '') {
        const cat = this.findCategoryById(id);
        if (cat) {
          return cat.id;
        }
      }
      return this.pickDefaultSearchSuggestCategoryId();
    },
    searchSuggestCanCreateInCategory() {
      const cat = this.findCategoryById(this.resolvedSearchSuggestCategoryId);
      return !!(cat && this.categoryCanEditTagsInCategory(cat));
    },
    searchSuggestColorHexNormalized() {
      return this.normalizePickerHex(this.searchSuggestTagColor);
    },
    newTagColorHexNormalized() {
      return this.normalizePickerHex(this.newTagColor);
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.isExpanded = !this.isMobileTagsViewport();
        this.resetSearchSuggestRowState();
        this.tagsPanelSearchQuery = '';
        this.loadCategories();
        return;
      }
      if (!val) {
        this.isExpanded = false;
        this.tagsPanelSearchQuery = '';
        this.resetSearchSuggestRowState();
        this.cancelEditCategory();
        this.cancelCreateTag();
        this.exitAllBulkModes();
        this.closeCategoryShareModal();
        this.unbindTagColorPickerOutsideClose();
      }
    },
    tagColorPickerShow() {
      this.syncTagColorPickerDocumentListener();
    },
    searchSuggestTagColorPickerShow() {
      this.syncTagColorPickerDocumentListener();
    },
    tagsPanelSearchQuery() {
      if (!(this.tagsPanelSearchQuery || '').trim().length) {
        this.resetSearchSuggestRowState();
        return;
      }
      if (this.searchSuggestCategoryId == null) {
        const pick = this.pickDefaultSearchSuggestCategoryId();
        if (pick != null) {
          this.searchSuggestCategoryId = pick;
        }
      }
      if (!this.searchSuggestRowColorInited) {
        const hex = this.pickRandomNewTagColorHex();
        this.searchSuggestTagColor = { hex, source: 'hex' };
        this.searchSuggestRowColorInited = true;
      }
    }
  },
  created() {
    this.debouncedOnTagsPanelSearch = myPlaginDebounce(() => {
      if (!this.show) {
        return;
      }
      this.loadCategories();
    }, 350);
  },
  mounted() {
    if (this.show) {
      this.isExpanded = !this.isMobileTagsViewport();
    }
  },
  beforeDestroy() {
    this.unbindTagColorPickerOutsideClose();
  },
  methods: {
    tagsToastError(key) {
      const msg = TAGS_TOAST[key];
      if (msg && this.$toastr && this.$toastr.e) {
        this.$toastr.e(msg);
      }
    },
    tagsToastSuccess(key) {
      const msg = TAGS_TOAST[key];
      if (msg && this.$toastr && this.$toastr.s) {
        this.$toastr.s(msg);
      }
    },
    /**
     * API id тега/категории → number; 'uncategorized' и строковые временные id без изменений.
     */
    normalizeTagOrCategoryId(val) {
      if (val === 'uncategorized') {
        return 'uncategorized';
      }
      if (val === null || val === undefined || val === '') {
        return val;
      }
      if (typeof val === 'string' && /^tag-new-\d+$/i.test(val)) {
        return val;
      }
      if (typeof val === 'string' && /^cat-new-\d+$/i.test(val)) {
        return val;
      }
      const n = Number(val);
      if (Number.isInteger(n) && n > 0) {
        return n;
      }
      return val;
    },
    idsEqualTags(a, b) {
      return (
        this.normalizeTagOrCategoryId(a) === this.normalizeTagOrCategoryId(b)
      );
    },
    closeModal() {
      this.closeCategoryShareModal();
      this.$emit('close');
    },
    isMobileTagsViewport() {
      if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
      }
      return window.matchMedia('(max-width: 767px)').matches;
    },
    openCategoryShareModal(cat) {
      if (!cat) {
        return;
      }
      this.shareCategory = cat;
      this.categoryShareModalOpen = true;
    },
    closeCategoryShareModal() {
      this.categoryShareModalOpen = false;
      this.shareCategory = null;
    },
    isUncategorizedCategory(cat) {
      if (!cat) {
        return false;
      }
      if (cat.isPendingCreate) {
        return false;
      }
      return cat.apiId == null || cat.id === 'uncategorized';
    },
    categoryCanRename(cat) {
      if (!cat || this.isUncategorizedCategory(cat) || cat.isPendingCreate) {
        return false;
      }
      if (!cat.isSharedFromOthers) {
        return true;
      }
      return cat.accessLevel != null && cat.accessLevel >= 2;
    },
    categoryCanShareCategory(cat) {
      if (!cat || this.isUncategorizedCategory(cat) || cat.isPendingCreate) {
        return false;
      }
      if (!cat.isSharedFromOthers) {
        return true;
      }
      return cat.accessLevel != null && cat.accessLevel >= 2;
    },
    categoryCanDeleteCategory(cat) {
      return (
        cat && !this.isUncategorizedCategory(cat) && !cat.isSharedFromOthers
      );
    },
    categoryCanEditTagsInCategory(cat) {
      if (!cat) {
        return false;
      }
      if (!cat.isSharedFromOthers) {
        return true;
      }
      return cat.accessLevel == null || cat.accessLevel >= 2;
    },
    mapApiTag(t) {
      if (!t) {
        return null;
      }
      const categoryId =
        t.category_id == null || t.category_id === ''
          ? null
          : this.normalizeTagOrCategoryId(t.category_id);
      return {
        id: this.normalizeTagOrCategoryId(t.id),
        categoryId,
        label: t.name,
        colorHex: t.color_hex,
        selected: false
      };
    },
    mapApiCategory(c, opts = {}) {
      const hasApiId =
        c && Object.prototype.hasOwnProperty.call(c, 'id') && c.id != null;
      const apiId = hasApiId ? this.normalizeTagOrCategoryId(c.id) : null;
      const id = hasApiId ? apiId : 'uncategorized';
      const accessLevel =
        c && c.access_level != null && c.access_level !== ''
          ? Number(c.access_level)
          : null;
      return {
        id,
        apiId,
        label: c && c.name ? c.name : '',
        tags: Array.isArray(c && c.tags)
          ? c.tags.map(this.mapApiTag).filter(Boolean)
          : [],
        accessLevel: Number.isFinite(accessLevel) ? accessLevel : null,
        isSharedFromOthers: !!opts.isSharedFromOthers
      };
    },
    /** Категория только для селекта при поиске: без тегов, чтобы не дублировать тяжёлый ответ. */
    mapLookupExtraCategory(c, opts = {}) {
      const m = this.mapApiCategory(c, opts);
      return { ...m, tags: [] };
    },
    setCategoriesLookupExtrasFromApiPayload(d) {
      const my = Array.isArray(d.my_categories) ? d.my_categories : [];
      const shared = Array.isArray(d.shared_categories)
        ? d.shared_categories
        : [];
      this.categoriesLookupExtras = [
        ...my.map(c => this.mapLookupExtraCategory(c)),
        ...shared.map(c =>
          this.mapLookupExtraCategory(c, { isSharedFromOthers: true })
        )
      ];
    },
    async loadCategories() {
      const gen = ++this.tagsCategoriesLoadGen;
      this.isLoadingCategories = true;
      const search = (this.tagsPanelSearchQuery || '').trim();
      try {
        let d;
        if (search) {
          const [rSearch, rFull] = await Promise.all([
            axios.get('/api/tags/categories', { params: { search } }),
            axios.get('/api/tags/categories')
          ]);
          if (gen !== this.tagsCategoriesLoadGen) {
            return;
          }
          d = rSearch && rSearch.data ? rSearch.data : {};
          const dFull = rFull && rFull.data ? rFull.data : {};
          this.setCategoriesLookupExtrasFromApiPayload(dFull);
        } else {
          const r = await axios.get('/api/tags/categories');
          if (gen !== this.tagsCategoriesLoadGen) {
            return;
          }
          d = r && r.data ? r.data : {};
          this.categoriesLookupExtras = [];
        }
        const my = Array.isArray(d.my_categories) ? d.my_categories : [];
        const shared = Array.isArray(d.shared_categories)
          ? d.shared_categories
          : [];
        this.myCategories = my.map(c => this.mapApiCategory(c));
        this.sharedCategories = shared.map(c =>
          this.mapApiCategory(c, { isSharedFromOthers: true })
        );
        if (search) {
          this.applyNestedTagsSelectionFromCategories();
          this.emitSelectedTags();
        } else {
          await this.loadTags(gen);
        }
        this.repairSearchSuggestCategoryAfterLoad();
      } catch (e) {
        this.tagsToastError('loadCategoriesError');
      } finally {
        if (gen === this.tagsCategoriesLoadGen) {
          this.isLoadingCategories = false;
        }
      }
    },
    repairSearchSuggestCategoryAfterLoad() {
      if (!(this.tagsPanelSearchQuery || '').trim().length) {
        return;
      }
      const id = this.searchSuggestCategoryId;
      if (id != null && id !== '' && this.findCategoryById(id)) {
        return;
      }
      const pick = this.pickDefaultSearchSuggestCategoryId();
      this.searchSuggestCategoryId = pick;
    },
    resetSearchSuggestRowState() {
      this.searchSuggestCategoryId = null;
      this.searchSuggestTagColorPickerShow = false;
      this.searchSuggestRowColorInited = false;
      this.searchSuggestTagColor = { hex: '#22B573', source: 'hex' };
      this.categoriesLookupExtras = [];
    },
    applyNestedTagsSelectionFromCategories() {
      const preselectedIds = Array.isArray(this.selectedTags)
        ? this.selectedTags
            .map(x => x && x.id)
            .filter(id => id != null && id !== '')
            .map(id => this.normalizeTagOrCategoryId(id))
        : [];
      this.exitAllBulkModes();
      const cats = this.categoriesForTagsPanel;
      for (const cat of cats) {
        const tags = Array.isArray(cat.tags) ? cat.tags : [];
        for (const t of tags) {
          this.$set(
            t,
            'selected',
            preselectedIds.some(pid => this.idsEqualTags(pid, t.id))
          );
        }
      }
    },
    async createCategoryApi(name) {
      const r = await axios.post('/api/tags/categories', { name });
      return r && r.data ? r.data : null;
    },
    async updateCategoryApi(categoryId, name) {
      return await axios.patch(`/api/tags/categories/${categoryId}`, { name });
    },
    async deleteCategoryApi(categoryId) {
      return await axios.delete(`/api/tags/categories/${categoryId}`);
    },
    async loadTags(expectedGen = null) {
      const r = await axios.get('/api/tags/items');
      if (expectedGen != null && expectedGen !== this.tagsCategoriesLoadGen) {
        return;
      }
      const items = Array.isArray(r && r.data) ? r.data : [];
      const preselectedIds = Array.isArray(this.selectedTags)
        ? this.selectedTags
            .map(x => x && x.id)
            .filter(id => id != null && id !== '')
            .map(id => this.normalizeTagOrCategoryId(id))
        : [];

      this.exitAllBulkModes();
      const cats = this.categoriesForTagsPanel;
      const tagSeeds = new Map();
      for (const c of cats) {
        tagSeeds.set(
          c.id,
          Array.isArray(c.tags) ? c.tags.map(t => ({ ...t })) : []
        );
        this.$set(c, 'tags', []);
      }

      for (const it of items) {
        const t = this.mapApiTag(it);
        if (!t) {
          continue;
        }
        t.selected = preselectedIds.some(pid => this.idsEqualTags(pid, t.id));
        const catApiId =
          it && Object.prototype.hasOwnProperty.call(it, 'category_id')
            ? it.category_id
            : null;
        const internalCatId =
          catApiId == null || catApiId === ''
            ? 'uncategorized'
            : this.normalizeTagOrCategoryId(catApiId);
        const cat = this.findCategoryById(internalCatId);
        if (!cat) {
          continue;
        }
        if (!cat.tags) {
          this.$set(cat, 'tags', []);
        }
        cat.tags.push(t);
      }
      for (const c of cats) {
        if (c.tags.length > 0) {
          continue;
        }
        const seed = tagSeeds.get(c.id) || [];
        for (const t of seed) {
          c.tags.push({
            ...t,
            selected: preselectedIds.some(pid => this.idsEqualTags(pid, t.id))
          });
        }
      }
      if (expectedGen != null && expectedGen !== this.tagsCategoriesLoadGen) {
        return;
      }
      this.emitSelectedTags();
    },
    exitAllBulkModes() {
      this.bulkDeleteMode = false;
      this.bulkMoveMode = false;
      this.isBulkMoving = false;
      this.bulkSelectedTagIds = [];
      this.moveTargetCategoryId = null;
    },
    enterBulkDeleteMode() {
      this.bulkMoveMode = false;
      this.moveTargetCategoryId = null;
      this.bulkDeleteMode = true;
      this.bulkSelectedTagIds = [];
      this.cancelCreateTag();
      this.cancelEditCategory();
    },
    exitBulkDeleteMode() {
      this.bulkDeleteMode = false;
      this.bulkSelectedTagIds = [];
    },
    enterBulkMoveMode() {
      this.bulkDeleteMode = false;
      this.bulkMoveMode = true;
      this.bulkSelectedTagIds = [];
      this.cancelCreateTag();
      this.cancelEditCategory();
      const list = this.categoriesForTagsPanel;
      this.moveTargetCategoryId = list.length > 0 ? list[0].id : null;
    },
    exitBulkMoveMode() {
      this.bulkMoveMode = false;
      this.bulkSelectedTagIds = [];
      this.moveTargetCategoryId = null;
    },
    batchMoveTagItemsApi(tagItemIds, categoryId) {
      return axios.put('/api/tags/items/batch-move', {
        tag_item_ids: tagItemIds,
        category_id: categoryId
      });
    },
    async confirmBulkMove() {
      if (
        !this.bulkSelectedTagIds.length ||
        this.moveTargetCategoryId == null ||
        this.isBulkMoving
      ) {
        return;
      }
      const ids = [];
      const seen = new Set();
      for (const raw of this.bulkSelectedTagIds) {
        const n = Number(raw);
        if (!Number.isInteger(n) || n <= 0) {
          continue;
        }
        if (seen.has(n)) {
          continue;
        }
        seen.add(n);
        ids.push(n);
      }
      if (!ids.length) {
        this.tagsToastError('bulkMoveInvalid');
        return;
      }
      if (ids.length > 200) {
        this.tagsToastError('bulkMoveLimit');
        return;
      }
      const rawCat = this.moveTargetCategoryId;
      let category_id = null;
      if (rawCat !== 'uncategorized' && rawCat !== '') {
        const c = Number(rawCat);
        if (Number.isInteger(c) && c > 0) {
          category_id = c;
        }
      }
      this.isBulkMoving = true;
      try {
        await this.batchMoveTagItemsApi(ids, category_id);
        await this.loadCategories();
        this.exitBulkMoveMode();
        this.emitSelectedTags();
        this.tagsToastSuccess('bulkMoveOk');
      } catch (e) {
        const d = e && e.response && e.response.data;
        const msg =
          d &&
          (typeof d.message === 'string'
            ? d.message
            : d.errors && d.errors.tag_item_ids && d.errors.tag_item_ids[0]);
        if (msg && this.$toastr && this.$toastr.e) {
          this.$toastr.e(msg);
        } else {
          this.tagsToastError('bulkMoveError');
        }
      } finally {
        this.isBulkMoving = false;
      }
    },
    isBulkTagSelected(tagId) {
      return this.bulkSelectedTagIds.some(id => this.idsEqualTags(id, tagId));
    },
    toggleBulkTag(tagId) {
      if (!tagId) {
        return;
      }
      const nid = this.normalizeTagOrCategoryId(tagId);
      if (this.isBulkTagSelected(nid)) {
        this.bulkSelectedTagIds = this.bulkSelectedTagIds.filter(
          id => !this.idsEqualTags(id, nid)
        );
        return;
      }
      this.bulkSelectedTagIds = this.bulkSelectedTagIds.concat([nid]);
    },
    getCategoryTagIds(cat) {
      const tags = cat && cat.tags ? cat.tags : [];
      return tags
        .map(t => (t ? this.normalizeTagOrCategoryId(t.id) : null))
        .filter(id => id != null && id !== '');
    },
    isBulkCategorySelected(cat) {
      const ids = this.getCategoryTagIds(cat);
      if (!ids.length) {
        return false;
      }
      return ids.every(id =>
        this.bulkSelectedTagIds.some(sid => this.idsEqualTags(sid, id))
      );
    },
    toggleBulkCategory(cat) {
      const ids = this.getCategoryTagIds(cat);
      if (!ids.length) {
        return;
      }
      const isAllSelected = ids.every(id =>
        this.bulkSelectedTagIds.some(sid => this.idsEqualTags(sid, id))
      );
      if (isAllSelected) {
        this.bulkSelectedTagIds = this.bulkSelectedTagIds.filter(
          sid => !ids.some(tid => this.idsEqualTags(sid, tid))
        );
        return;
      }
      const set = new Set(this.bulkSelectedTagIds);
      for (const id of ids) {
        set.add(this.normalizeTagOrCategoryId(id));
      }
      this.bulkSelectedTagIds = Array.from(set);
    },
    async confirmBulkDelete() {
      if (!this.bulkSelectedTagIds.length || this.isBulkDeleting) {
        return;
      }
      const ids = [];
      const seen = new Set();
      for (const raw of this.bulkSelectedTagIds) {
        const n = Number(raw);
        if (!Number.isInteger(n) || n <= 0) {
          continue;
        }
        if (seen.has(n)) {
          continue;
        }
        seen.add(n);
        ids.push(n);
      }
      if (!ids.length) {
        this.tagsToastError('bulkDeleteInvalid');
        return;
      }
      if (ids.length > 200) {
        this.tagsToastError('bulkDeleteLimit');
        return;
      }
      this.isBulkDeleting = true;
      try {
        await this.deleteTagsBatchApi(ids);
        const cats = this.categoriesForTagsPanel;
        for (const c of cats) {
          const list = c && c.tags ? c.tags : [];
          const next = list.filter(
            t => t && !ids.some(delId => this.idsEqualTags(delId, t.id))
          );
          if (next.length !== list.length) {
            this.$set(c, 'tags', next);
          }
        }
        this.exitBulkDeleteMode();
        this.emitSelectedTags();
        this.tagsToastSuccess('bulkDeleteOk');
      } catch (e) {
        this.tagsToastError('bulkDeleteError');
      } finally {
        this.isBulkDeleting = false;
      }
    },
    toggleTagSelected(tag) {
      if (!tag) {
        return;
      }
      this.$set(tag, 'selected', !tag.selected);
      this.emitSelectedTags();
    },
    emitSelectedTags() {
      const out = [];
      const panelTagIds = new Set();
      const cats = this.categoriesForTagsPanel;
      for (const cat of cats) {
        const tags = cat && cat.tags ? cat.tags : [];
        for (const t of tags) {
          if (!t) {
            continue;
          }
          panelTagIds.add(this.normalizeTagOrCategoryId(t.id));
          if (t.selected) {
            out.push({
              id: this.normalizeTagOrCategoryId(t.id),
              name: t.label,
              color_hex: t.colorHex,
              category_id:
                t.categoryId == null
                  ? null
                  : this.normalizeTagOrCategoryId(t.categoryId)
            });
          }
        }
      }
      const propTags = Array.isArray(this.selectedTags)
        ? this.selectedTags
        : [];
      for (const x of propTags) {
        if (!x || x.id == null || x.id === '') {
          continue;
        }
        const id = this.normalizeTagOrCategoryId(x.id);
        if (panelTagIds.has(id)) {
          continue;
        }
        out.push({
          id,
          name: x.name,
          color_hex: x.color_hex,
          category_id:
            x.category_id == null || x.category_id === ''
              ? null
              : this.normalizeTagOrCategoryId(x.category_id)
        });
      }
      this.$emit('selected-change', out);
    },
    async getTagApi(tagId) {
      const r = await axios.get(`/api/tags/items/${tagId}`);
      return r && r.data ? r.data : null;
    },
    async createTagApi(payload) {
      const r = await axios.post('/api/tags/items', payload);
      return r && r.data ? r.data : null;
    },
    async updateTagApi(tagId, payload) {
      const r = await axios.patch(`/api/tags/items/${tagId}`, payload);
      return r && r.data ? r.data : null;
    },
    async deleteTagApi(tagId) {
      return await axios.delete(`/api/tags/items/${tagId}`);
    },
    async deleteTagsBatchApi(tagItemIds) {
      return await axios.delete('/api/tags/items/batch', {
        data: { tag_item_ids: tagItemIds }
      });
    },
    scrollToCategory(categoryId) {
      const container = this.$refs.rightPanel;
      const r = this.$refs[`groupTitle-${categoryId}`];
      const titleEl = Array.isArray(r) ? r[0] : r;
      if (!container || !titleEl) {
        return;
      }
      const top = titleEl.offsetTop - container.offsetTop;
      container.scrollTo({
        top,
        behavior: 'smooth'
      });
    },
    pickRandomNewTagColorHex() {
      const pool = ['#22B573', '#E64D4D', '#7EB0FF', '#9CA8BC'];
      return pool[Math.floor(Math.random() * pool.length)];
    },
    normalizePickerHex(colorObj) {
      const raw =
        colorObj &&
        (colorObj.hex8 || colorObj.hex || '').toString().trim().toUpperCase();
      return this.normalizeHex6(raw);
    },
    normalizeHex6(raw) {
      if (!raw) {
        return '#22B573';
      }
      let s = raw.replace(/^#/, '').replace(/[^0-9A-F]/gi, '');
      if (s.length >= 8) {
        s = s.slice(0, 6);
      }
      if (s.length === 3) {
        s = s
          .split('')
          .map(c => c + c)
          .join('');
      }
      if (s.length < 6) {
        return '#22B573';
      }
      return `#${s.slice(0, 6).toUpperCase()}`;
    },
    syncTagColorPickerDocumentListener() {
      if (this.tagColorPickerShow || this.searchSuggestTagColorPickerShow) {
        this.bindTagColorPickerOutsideClose();
      } else {
        this.unbindTagColorPickerOutsideClose();
      }
    },
    toggleTagColorPicker() {
      this.searchSuggestTagColorPickerShow = false;
      this.tagColorPickerShow = !this.tagColorPickerShow;
    },
    toggleSearchSuggestTagColorPicker() {
      this.tagColorPickerShow = false;
      this.searchSuggestTagColorPickerShow =
        !this.searchSuggestTagColorPickerShow;
    },
    closeTagColorPicker() {
      this.tagColorPickerShow = false;
      this.searchSuggestTagColorPickerShow = false;
    },
    bindTagColorPickerOutsideClose() {
      this.unbindTagColorPickerOutsideClose();
      document.addEventListener(
        'pointerdown',
        this.onPointerDownOutsideTagColorPicker,
        true
      );
    },
    unbindTagColorPickerOutsideClose() {
      document.removeEventListener(
        'pointerdown',
        this.onPointerDownOutsideTagColorPicker,
        true
      );
    },
    onPointerDownOutsideTagColorPicker(e) {
      if (!this.tagColorPickerShow && !this.searchSuggestTagColorPickerShow) {
        return;
      }
      const root = this.$el;
      const t = e.target;
      if (!root || !(root instanceof Element) || !(t instanceof Element)) {
        return;
      }
      const wrap = t.closest('.tags-modal__color-picker-wrap');
      if (wrap && root.contains(wrap)) {
        return;
      }
      const chrome = t.closest('.vc-chrome');
      if (chrome && root.contains(chrome)) {
        return;
      }
      this.closeTagColorPicker();
    },
    tagDotPresetClass(tag) {
      if (tag.colorHex) {
        return null;
      }
      return tag.dot ? `tags-dot--${tag.dot}` : null;
    },
    tagDotHexStyle(tag) {
      if (!tag.colorHex) {
        return {};
      }
      return { backgroundColor: this.normalizeHex6(tag.colorHex) };
    },
    openCreateTag() {
      const list = this.categoriesForTagsPanel;
      if (!list.length) {
        return;
      }
      this.exitAllBulkModes();
      const container = this.$refs.rightPanel;
      if (container && typeof container.scrollTo === 'function') {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      }
      this.isCreatingTag = true;
      this.tagFormMode = 'create';
      this.editingTagId = null;
      this.editingTagFromCategoryId = null;
      this.newTagLabel = '';
      const hex = this.pickRandomNewTagColorHex();
      this.newTagColor = { hex, source: 'hex' };
      this.tagColorPickerShow = false;
      this.newTagCategoryId = list[0].id;
    },
    isInlineEditingTag(cat, tag) {
      return (
        this.tagFormMode === 'edit' &&
        tag &&
        this.editingTagId === tag.id &&
        this.editingTagFromCategoryId === cat.id
      );
    },
    onTagOptionClick(cat, tag) {
      if (this.isInlineEditingTag(cat, tag)) {
        return;
      }
      if (this.bulkSelectUiActive) {
        this.toggleBulkTag(tag.id);
        return;
      }
      this.toggleTagSelected(tag);
    },
    openEditTag(cat, tag) {
      if (!cat || !tag || !this.categoryCanEditTagsInCategory(cat)) {
        return;
      }
      this.exitAllBulkModes();
      this.isCreatingTag = false;
      this.tagFormMode = 'edit';
      this.editingTagId = tag.id;
      this.editingTagFromCategoryId = cat.id;
      this.newTagLabel = tag.label || '';
      this.newTagCategoryId = cat.id;
      const hex = this.normalizeHex6(tag.colorHex || tag.hex || tag.color);
      this.newTagColor = { hex, source: 'hex' };
      this.tagColorPickerShow = false;
    },
    cancelCreateTag() {
      this.isCreatingTag = false;
      this.tagFormMode = 'create';
      this.editingTagId = null;
      this.editingTagFromCategoryId = null;
      this.newTagLabel = '';
      this.newTagCategoryId = null;
      this.newTagColor = { hex: '#22B573', source: 'hex' };
      this.tagColorPickerShow = false;
    },
    async confirmCreateTagFromSearch() {
      const name = this.tagsPanelSearchTrimmed;
      if (!name) {
        return;
      }
      const targetCat = this.findCategoryById(
        this.resolvedSearchSuggestCategoryId
      );
      if (!targetCat || !this.categoryCanEditTagsInCategory(targetCat)) {
        return;
      }
      this.newTagLabel = name;
      this.newTagCategoryId = targetCat.id;
      this.newTagColor = {
        hex: this.searchSuggestTagColor.hex || '#22B573',
        source: this.searchSuggestTagColor.source || 'hex'
      };
      this.tagFormMode = 'create';
      this.editingTagId = null;
      this.editingTagFromCategoryId = null;
      this.isCreatingTag = false;
      const ok = await this.confirmCreateTag();
      if (ok) {
        await this.loadCategories();
      }
    },
    async confirmCreateTag() {
      const name = this.newTagLabel.trim();
      if (!name) {
        return false;
      }
      const targetCat = this.findCategoryById(this.newTagCategoryId);
      if (!targetCat) {
        return false;
      }
      if (!targetCat.tags) {
        this.$set(targetCat, 'tags', []);
      }
      const hex = this.normalizePickerHex(this.newTagColor);

      if (this.tagFormMode === 'edit' && this.editingTagId) {
        const res = this.findTagById(this.editingTagId);
        if (!res || !res.tag) {
          return false;
        }
        const payload = {
          name,
          color_hex: hex,
          category_id:
            targetCat && targetCat.apiId != null ? targetCat.apiId : null
        };
        try {
          const updated = await this.updateTagApi(this.editingTagId, payload);
          const mapped = this.mapApiTag(updated);
          if (mapped) {
            res.tag.label = mapped.label;
            res.tag.colorHex = mapped.colorHex;
            if (mapped.categoryId != null) {
              res.tag.categoryId = mapped.categoryId;
            }
          } else {
            res.tag.label = name;
            res.tag.colorHex = hex;
          }

          if (!this.idsEqualTags(res.categoryId, this.newTagCategoryId)) {
            const fromCat = this.findCategoryById(res.categoryId);
            if (fromCat && fromCat.tags) {
              fromCat.tags = fromCat.tags.filter(
                t => !this.idsEqualTags(t.id, this.editingTagId)
              );
            }
            targetCat.tags.unshift(res.tag);
            this.$set(res.tag, 'categoryId', targetCat.id);
          }
          this.cancelCreateTag();
          return true;
        } catch (e) {
          this.tagsToastError('saveTagError');
          return false;
        }
      }

      try {
        const created = await this.createTagApi({
          name,
          color_hex: hex,
          category_id:
            targetCat && targetCat.apiId != null ? targetCat.apiId : null
        });
        const mapped = this.mapApiTag(created);
        if (mapped) {
          targetCat.tags.unshift(mapped);
        } else {
          const id = `tag-new-${this.nextTagId}`;
          this.nextTagId += 1;
          targetCat.tags.unshift({
            id,
            label: name,
            colorHex: hex,
            selected: false
          });
        }
        this.cancelCreateTag();
        return true;
      } catch (e) {
        this.tagsToastError('saveTagError');
        return false;
      }
    },
    async deleteEditingTag() {
      if (this.tagFormMode !== 'edit' || !this.editingTagId) {
        this.cancelCreateTag();
        return;
      }
      const tagId = this.editingTagId;
      const res = this.findTagById(tagId);
      try {
        await this.deleteTagApi(tagId);
        if (res && res.categoryId != null) {
          const fromCat = this.findCategoryById(res.categoryId);
          if (fromCat && fromCat.tags) {
            fromCat.tags = fromCat.tags.filter(
              t => !this.idsEqualTags(t.id, tagId)
            );
          }
        }
        this.cancelCreateTag();
      } catch (e) {
        this.tagsToastError('deleteTagError');
      }
    },
    findTagById(tagId) {
      const list = this.categoriesForTagsPanel;
      for (const cat of list) {
        const tags = cat && cat.tags ? cat.tags : [];
        const t = tags.find(x => this.idsEqualTags(x.id, tagId));
        if (t) {
          return { tag: t, categoryId: cat.id };
        }
      }
      return null;
    },
    createDefaultTagsForCategory(categoryId) {
      return [
        {
          id: `${categoryId}-tag-1`,
          label: 'תג 1',
          dot: 'teal',
          selected: false
        },
        {
          id: `${categoryId}-tag-2`,
          label: 'תג 2',
          dot: 'yellow',
          selected: true
        }
      ];
    },
    onCategoryEditInputFocus(event) {
      if (!this.categoryEditShouldSelect) {
        return;
      }
      this.categoryEditShouldSelect = false;
      const el = event.target;
      if (el && typeof el.select === 'function') {
        el.select();
      }
    },
    startEditCategory(cat) {
      if (!this.categoryCanRename(cat)) {
        return;
      }
      this.categoryEditShouldSelect = true;
      this.editingCategoryId = cat.id;
      this.editingCategoryDraft = cat.label;
    },
    cancelEditCategory() {
      const id = this.editingCategoryId;
      if (id) {
        const cat = this.findCategoryById(id);
        if (cat && cat.isPendingCreate) {
          this.myCategories = this.myCategories.filter(c => c.id !== id);
        }
      }
      this.editingCategoryId = null;
      this.editingCategoryDraft = '';
      this.categoryEditShouldSelect = false;
    },
    findCategoryById(id) {
      if (id === null || id === undefined || id === '') {
        return null;
      }
      let cat = this.myCategories.find(c => this.idsEqualTags(c.id, id));
      if (cat) {
        return cat;
      }
      cat = this.sharedCategories.find(c => this.idsEqualTags(c.id, id));
      if (cat) {
        return cat;
      }
      return (
        this.categoriesLookupExtras.find(c => this.idsEqualTags(c.id, id)) ||
        null
      );
    },
    pickDefaultSearchSuggestCategoryId() {
      const opts = this.categoryTreeselectOptionsSearchRow;
      if (!opts.length) {
        return null;
      }
      for (const o of opts) {
        const cat = this.findCategoryById(o.id);
        if (cat && !this.isUncategorizedCategory(cat)) {
          return cat.id;
        }
      }
      const fallback = this.findCategoryById(opts[0].id);
      return fallback ? fallback.id : null;
    },
    async confirmEditCategory() {
      if (!this.editingCategoryId) {
        return;
      }
      const cat = this.findCategoryById(this.editingCategoryId);
      if (!cat) {
        this.cancelEditCategory();
        return;
      }
      const t = this.editingCategoryDraft.trim();
      if (cat.isPendingCreate) {
        if (!t) {
          return;
        }
        try {
          const created = await this.createCategoryApi(t);
          if (!created) {
            this.tagsToastError('createCategoryError');
            return;
          }
          const mapped = this.mapApiCategory(created);
          const idx = this.myCategories.findIndex(c => c.id === cat.id);
          if (idx !== -1) {
            this.myCategories.splice(idx, 1, mapped);
          }
          this.editingCategoryId = null;
          this.editingCategoryDraft = '';
          this.categoryEditShouldSelect = false;
          await this.loadCategories();
        } catch (e) {
          this.tagsToastError('createCategoryError');
        }
        return;
      }
      if (t && cat.apiId != null) {
        const prev = cat.label;
        cat.label = t;
        try {
          await this.updateCategoryApi(cat.apiId, t);
        } catch (e) {
          cat.label = prev;
          this.tagsToastError('renameCategoryError');
          return;
        }
      }
      this.cancelEditCategory();
    },
    async deleteEditingCategory() {
      if (!this.editingCategoryId) {
        return;
      }
      const id = this.editingCategoryId;
      const cat = this.findCategoryById(id);
      if (!this.categoryCanDeleteCategory(cat)) {
        return;
      }
      if (cat.apiId == null) {
        this.cancelEditCategory();
        return;
      }
      try {
        await this.deleteCategoryApi(cat.apiId);
        this.myCategories = this.myCategories.filter(c => c.id !== id);
        this.sharedCategories = this.sharedCategories.filter(c => c.id !== id);
        this.cancelEditCategory();
      } catch (e) {
        this.tagsToastError('deleteCategoryError');
      }
    },
    addMyCategoryLikeSectionTitle() {
      const existing = this.myCategories.find(c => c.isPendingCreate);
      if (existing) {
        this.editingCategoryId = existing.id;
        this.editingCategoryDraft = '';
        this.categoryEditShouldSelect = true;
        return;
      }
      if (this.editingCategoryId) {
        this.cancelEditCategory();
      }
      const id = `cat-new-${this.myCategoryNextId++}`;
      const pending = {
        id,
        apiId: null,
        label: '',
        tags: [],
        isPendingCreate: true,
        accessLevel: null,
        isSharedFromOthers: false
      };
      this.myCategories.unshift(pending);
      this.editingCategoryId = id;
      this.editingCategoryDraft = '';
      this.categoryEditShouldSelect = true;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .vc-chrome-toggle-icon {
  margin-top: 0 !important;
}
::v-deep .vc-chrome-toggle-icon-highlight {
  display: none !important;
}
.new-tags-archive {
  margin-top: auto;
  border-top: 1px solid #e9eef7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 8px 10px; */
  min-height: 44px;
}
.tags-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(18, 32, 56, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.tags-modal__shell {
  position: relative;
  width: 620px;
  max-width: 100%;
  flex-shrink: 0;
}

.tags-modal__card {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(33, 52, 84, 0.2);
  border: 1px solid #d8e3f2;
  overflow: hidden;
  display: flex;
  height: 384px;
  position: relative;
  z-index: 7;
}

.tags-modal__search-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #eef2f8;
}

.tags-modal__search {
  flex: 1;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #cfe0f8;
  padding: 0 12px;
  font-size: 14px;
}

.tags-modal__body {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: row-reverse;
}

.tags-modal__left {
  width: 44px;
  background: #f7f8fa;
  border-left: 1px solid #e9eef7;
  transition: width 0.2s ease;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  height: 100%;
}

.tags-modal__left--open {
  width: 246px;
}

.tags-modal__left-handle {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 14px;
  cursor: pointer;
}

.tags-modal__left-handle-spacer {
  flex: 1;
}

.tags-modal__left-panel {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}

.tags-modal__left-group--first {
  border-bottom: 2px solid #e9eef7;
  height: 173px;
  overflow: auto;
}

.tags-modal__left-top {
  display: flex;
  align-items: center;
  justify-content: stretch;
  padding: 6px 12px;
  flex-direction: row;
  position: sticky;
  top: 0px;
  background: #f7f8fa;
  cursor: pointer;
  transition: background-color 0.22s ease;
}

.tags-modal__left-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  flex-direction: row;
}

.tags-modal__left-top-section-title {
  font-weight: 500;
  font-size: 12px;
  // line-height: 16px;
  text-align: right;
  color: #8e9ebb;
  user-select: none;
  flex-shrink: 0;
  min-width: 0;
}

.tags-modal__left-top:hover {
  background-color: #eceff4;
}

.tags-modal__left-top-create {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-direction: row;
}

.tags-modal__left-top-create-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #409fff;
  user-select: none;
}

.tags-modal__left-top:hover .tags-modal__left-top-section-title {
  color: #5a6f95;
}

.tags-modal__left-subtitle {
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 2%;
  text-align: right;
  vertical-align: middle;
  color: #8e9ebb;
  padding: 8px 12px;
  background: #f7f8fa;
  position: sticky;
  top: 0;
}

.tags-modal__left-add {
  border: 0;
  background: transparent;
  color: #409fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

// .tags-modal__left-add svg {
//   display: block;
//   transform: rotate(0deg);
//   transition: transform 1s cubic-bezier(0.34, 1.2, 0.64, 1);
// }

// .tags-modal__left-top:hover .tags-modal__left-add svg {
//   transform: rotate(360deg);
// }

.tags-modal__left-item-wrap {
  width: 100%;
}

.tags-modal__left-item {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 4px 12px;
  text-align: right;
  color: #5a6f95;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  box-sizing: border-box;
  // border-radius: 8px;
  transition: background-color 0.15s ease;
}

.tags-modal__left-item:hover {
  background-color: #e0effe;
}

.tags-modal__left-item-label {
  flex: 1;
  min-width: 0;
}

.tags-modal__shared-access-badge {
  display: inline-block;
  margin-inline-start: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #eef2f8;
  color: #5a6f95;
  font-size: 10px;
  font-weight: 600;
  vertical-align: middle;
}

.tags-modal__left-shared-empty {
  padding: 8px 12px 12px;
  font-size: 12px;
  color: #8e9ebb;
  text-align: right;
}

.tags-modal__left-item-edit {
  padding: 4px 12px 10px;
  box-sizing: border-box;
}

.tags-modal__left-item-name-bar {
  background: rgba(64, 159, 255, 0.14);
  color: #38455d;
  font-size: 12px;
  font-weight: 500;
  text-align: right;
  padding: 8px 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.tags-modal__left-item-input {
  width: 100%;
  box-sizing: border-box;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #409fff;
  padding: 0 10px;
  font-size: 13px;
  text-align: right;
  color: #38455d;
  background: #fff;
}

.tags-modal__left-item-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 159, 255, 0.2);
}

.tags-modal__left-item-edit-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
  gap: 8px;
}

.tags-modal__left-item-edit-actions .tags-modal__left-item-edit-btn:hover {
  background: rgba(90, 111, 149, 0.06);
}

.tags-modal__left-item-edit-btn {
  border: 0;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  margin-right: auto;
  transition: background-color 0.15s ease;
}

.tags-modal__left-item-edit-btn:hover {
  background: rgba(90, 111, 149, 0.08);
}

.tags-modal__left-item-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-direction: row-reverse;
}
.tags-modal__left-action-btn {
  border: 0;
  background: transparent;
  padding: 0;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.tags-modal__left-group--shared .tags-modal__left-item:last-child {
  border-bottom: 0;
}
.tags-modal__left-group {
  height: 160px;
  overflow: auto;
}

.tags-modal__left-footer {
  margin-top: auto;
  border-top: 1px solid #e9eef7;
  display: flex;

  justify-content: flex-end;
  align-items: center;
  padding: 8px 10px;
  // min-height: 44px;
  height: 50px;
}

.tags-modal__right {
  flex: 1;
  border-right: 1px solid #eef2f8;
  padding: 18px 0;
  overflow: auto;
}

.tags-modal__option--search-suggest {
  cursor: default;
  border-top: 1px solid #eef2f8;
}

.tags-modal__option-search-aside {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 55%;
}

.tags-modal__option-search-aside > *:first-child {
  flex: 1;
  min-width: 0;
}

.tags-modal__search-suggest-create {
  border: 0;
  background: transparent;
  padding: 0 2px;
  font-size: 14px;
  font-weight: 600;
  color: #409fff;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
}

.tags-modal__search-suggest-create:disabled {
  color: #b8c4d9;
  cursor: not-allowed;
}

.tags-modal__create-tag {
  margin-bottom: 18px;
  padding-bottom: 16px;
  margin-left: 8px;
  margin-right: 8px;
}

.tags-modal__color-picker-wrap {
  position: relative;
  flex-shrink: 0;
}

.tags-modal__color-picker-wrap ::v-deep .vc-chrome {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  left: auto;
  z-index: 30;
  border-radius: 8px !important;
  box-shadow: 0 8px 28px rgba(33, 52, 84, 0.18);
}

.tags-modal__create-tag-dot-btn {
  border: 0;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.tags-modal__create-tag-name {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 10px;
  border: 1px solid #409fff;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  position: relative;
}

.tags-modal__create-tag-input {
  flex: 1;
  min-width: 0;
  border: 0;
  height: 38px;
  font-size: 14px;
  text-align: right;
  color: #38455d;
  outline: none;
}

.tags-modal__create-tag-select-wrap {
  margin-top: 10px;
}

.tags-modal__create-tag-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  gap: 8px;
}

.tags-modal__create-tag-footer--create-only {
  justify-content: flex-end;
}

.tags-modal__right-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.tags-modal__group + .tags-modal__group {
  margin-top: 18px;
}

.tags-modal__group-title {
  text-align: right;
  color: #8ea0bd;
  font-size: 12px;
  // margin-bottom: 10px;
  padding: 4px 8px;
}

.tags-modal__option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  color: #2f3f5e;
  font-size: 14px;
  // margin-bottom: 10px;
  flex-direction: row;
  padding: 4px 8px;
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.tags-modal__option--bulk {
  padding-right: 26px;
}

.tags-modal__option-bulk-check {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
}

.tags-modal__group-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.tags-modal__group-bulk-check {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
}

.tags-modal__option:hover {
  background-color: #eef7ff;
}

.tags-modal__option-main {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
  min-width: 0;
}

.tags-modal__option-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-modal__option-edit-btn {
  border: 0;
  background: transparent;
  padding: 0;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.tags-modal__option-edit-btn:hover {
  background: rgba(90, 111, 149, 0.08);
}

.tags-modal__option--editing {
  cursor: default;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 8px;
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 8px;
  /* background: #f7fbff; */
  border: 1px solid #d8e8fb;
}

.tags-modal__option--editing:hover {
  background: #f7fbff;
}

.tags-modal__option-inline-edit {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tags-modal__option-inline-edit-top {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.tags-modal__option-inline-edit-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  padding-top: 2px;
}

.tags-modal__option-inline-edit-delete {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.tags-modal__option-inline-edit-actions {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.tags-modal__option-input {
  flex: 1;
  min-width: 0;
  border: 1px solid #409fff;
  border-radius: 8px;
  height: 36px;
  padding: 0 10px;
  font-size: 14px;
  text-align: right;
  color: #38455d;
  background: #fff;
  outline: none;
  box-sizing: border-box;
}

.tags-modal__option-inline-edit-category {
  width: 100%;
  min-width: 0;
}

.tags-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
}

.tags-dot--teal {
  background: #10b8b2;
}

.tags-dot--yellow {
  background: #d2bd00;
}

.tags-dot--pink {
  background: #f5a8ff;
}

.tags-dot--blue {
  background: #7eb0ff;
}

.tags-dot--green {
  background: #22b573;
}

.tags-dot--red {
  background: #e64d4d;
}

.tags-dot--grey {
  background: #9ca8bc;
}

.tags-check {
  color: #4f6a97;
  font-size: 17px;
  font-weight: 600;
  width: 15px;
}

.tags-modal__footer {
  border-top: 1px solid #eef2f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  min-height: 50px;
  margin-top: auto;
  flex-direction: row-reverse;
}

.tags-modal__footer-actions .tags-modal__mobile-categories-toggle {
  display: none;
}

.tags-modal__bulk-back {
  border: 0;
  background: transparent;
  padding: 0;
  width: 36px;
  height: 24px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.tags-modal__bulk-back:hover {
  background: rgba(90, 111, 149, 0.08);
}

.tags-modal__bulk-delete {
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #ff6052;
  font-size: 15px;
  font-weight: 500;
  flex-direction: row-reverse;
}
.tags-modal__bulk-delete:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.tags-modal__footer-move {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  flex-direction: row;
}

.tags-modal__footer-move-center {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  flex-direction: row;
}

.tags-modal__footer-move-select-wrap {
  flex: 1;
  min-width: 0;
}

.tags-modal__bulk-move-apply {
  border: 0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #409fff;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}

.tags-modal__bulk-move-apply:hover:not(:disabled) {
  background: #2f7fe0;
}

.tags-modal__bulk-move-apply:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.tags-modal__footer-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-direction: row;
}

.tags-modal__footer-actions .tags-modal__icon-btn {
  border-radius: 8px;
  transition: background-color 0.15s ease;
}

.tags-modal__footer-actions .tags-modal__icon-btn:hover {
  background: rgba(90, 111, 149, 0.1);
}

.tags-modal__footer-actions .tags-modal__icon-btn:active {
  background: rgba(90, 111, 149, 0.16);
}

.tags-modal__icon-btn {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tags-modal__create-btn {
  border: 0;
  background: transparent;
  color: #409fff;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  flex-direction: row-reverse;
  padding: 0;
}

.tags-modal__create-btn:hover {
  color: #2f7fe0;
}

.tags-modal__create-btn:hover svg path {
  stroke: #2f7fe0;
}

@media (max-width: 767px) {
  .tags-modal {
    align-items: center;
    padding: 12px;
  }

  .tags-modal__shell {
    width: 100%;
    max-width: none;
  }

  .tags-modal__card {
    height: min(450px, calc(100vh - 24px));
    max-height: calc(100vh - 24px);
  }

  .tags-modal__body {
    position: relative;
  }

  .tags-modal__left-handle {
    display: none !important;
  }

  .tags-modal__left {
    position: absolute;
    inset-inline-end: 0;
    top: 0;
    bottom: 0;
    width: 0 !important;
    min-width: 0 !important;
    max-width: none;
    border: none;
    overflow: visible;
    background: transparent;
    z-index: 15;
    pointer-events: none;
  }

  .tags-modal__left--open {
    width: 0 !important;
  }

  .tags-modal__left-panel {
    position: absolute;
    inset: auto;
    inset-inline-end: 0;
    top: 0;
    bottom: 0;
    width: min(78%, 280px);
    max-width: calc(100% - 56px);
    min-width: 200px;
    border-inline-start: 1px solid #e9eef7;
    box-shadow: -6px 0 24px rgba(33, 52, 84, 0.12);
    z-index: 16;
    pointer-events: auto;
    background: #f7f8fa;
  }

  .tags-modal__footer-actions .tags-modal__mobile-categories-toggle {
    display: inline-flex;
  }
}
</style>
